<template>
  <Infomation :item="infoItem" heading="お知らせ" />
  <HeadingLv1 text="マイページ" />
  <div class="u-containar">
    <TileButtons :items="buttonItems" />
    <div class="pcWrap">
      <section class="section">
        <HeadingLv3 text="基本情報" />
        <SimpleLinkList :items="kihon" />
      </section>
      <section class="section">
        <HeadingLv3 text="その他" />
        <SimpleLinkList :items="others" />
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { reactive } from 'vue'
import Infomation from '@/components/block/Infomation.vue'
import TileButtons from '@/components/block/TileButtons.vue'
import SimpleLinkList from '@/components/block/SimpleLinkList.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { axiosSetting } from '@/utils/axiosSetting'

export default {
  name: 'MyPage',

  components: {
    TileButtons,
    SimpleLinkList,
    HeadingLv1,
    HeadingLv3,
    Infomation
  },

  setup() {
    const router = useRouter()
    const store = useStore()

    const userInfo = store.state.userInfo

    const buttonItems = [
      {
        icon: 'heart',
        label: 'お気に入り病院一覧',
        link: '/mypage/bookmark/list',
        badgeNum:
          userInfo.favorite_history.length + userInfo.s_favorite_history.length
      },
      {
        icon: 'document',
        label: '資料請求一覧',
        link: '/mypage/document_request/list',
        badgeNum:
          userInfo.request_history.length + userInfo.s_request_history.length
      },
      {
        icon: 'hospital-02',
        label: '病院見学一覧',
        link: '/mypage/visit_application/list',
        badgeNum:
          userInfo.inspection_history.length +
          userInfo.s_inspection_history.length
      },
      {
        icon: 'calendar',
        label: '申込イベント一覧',
        link: '/mypage/event/list',
        badgeNum: userInfo.event_history ? userInfo.event_history.length : 0
      }
      // {
      //   icon: 'ping-02',
      //   label: 'ブースチェックイン',
      //   link: '/mypage/check-in',
      //   badgeNum: 3
      // }
    ]

    const kihon = [
      {
        heading: '登録情報の確認・変更',
        link: '/mypage/user/profile',
        label: userInfo.required_flg ? '' : '未設定項目あり'
      },
      {
        heading: '保存した検索条件',
        link: '/mypage/saved_search_conditions/list',
        label: ''
      }
      // {
      //   heading: 'パスワード変更',
      //   link: '',
      //   label: ''
      // }
      // {
      //   heading: '登録情報',
      //   link: '',
      //   label: ''
      // }
    ]

    const others = [
      {
        heading: 'お問い合わせ',
        link: '/contact/input',
        label: ''
      },
      //{
      //  heading: 'パスワードを再設定',
      //  link: '/password',
      //  label: ''
      //},
      //{
      //  heading: 'パスワードを再設定',
      //  link: '/password',
      //  label: ''
      //},
      {
        heading: 'メールマガジン配信設定',
        link: '/mypage/user/profile/main_email_flg',
        label: ''
      },
      {
        heading: 'ログアウト',
        link: '/logout',
        label: ''
      },
      {
        heading: '退会',
        link: '/mypage/leave/input',
        label: ''
      }
    ]

    const toList = () => {
      router.push({ path: '/events/list' })
    }

    const getInfo = axiosSetting('cms', 'block')
    const infoItem = reactive<any>({})

    getInfo
      .get(
        `${process.env.VUE_APP_WPAPI_URL}wp-json/acf/v3/options/options/module_mini_news`
      )
      .then((res: any) => {
        console.log(res.data)
        infoItem.text = res.data.module_mini_news.text
        infoItem.url = res.data.module_mini_news.url
        infoItem.blank = res.data.module_mini_news.blank
      })

    return {
      toList,
      buttonItems,
      kihon,
      others,
      infoItem
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.pcWrap {
  @include mixins.media() {
    display: flex;
    margin: 0 -20px;
  }
}

.section {
  margin-top: 40px;
  margin-bottom: 40px;
  @include mixins.media() {
    flex-basis: 50%;
    margin-right: 20px;
    margin-left: 20px;
  }
}
</style>
